import {
  init,
  getLocaleFromNavigator,
  getLocaleFromQueryString,
  register,
} from 'svelte-i18n';
import { LOCAL_STORAGE_KEY_LANGUAGE } from './constants';

const STRINGS_FILE_URL_TEMPLATE = '/locale/{locale}.json';

function getLocaleFromLocalStorage(key) {
  return localStorage.getItem(key);
}

/**
 * @param {string} _locale
 * @returns promisified json object or null (if locale file retrieval fails)
 */
const fetchStrings = async (_locale) => {
  const stringsFileUrl = STRINGS_FILE_URL_TEMPLATE.replace('{locale}', _locale);
  const response = await fetch(stringsFileUrl);
  const strings = await response.json();
  return typeof response.json === 'function' ? strings : null;
};

/**
 * Registers loaders for specificed `locale`s and initializes setup configuration for svelte-i18n.
 */
const setupI18n = async () => {
  register('en', () => fetchStrings('en-US'));
  register('en-US', () => fetchStrings('en-US'));
  register('ja', () => fetchStrings('ja-JP'));
  register('ja-JP', () => fetchStrings('ja-JP'));
  register('es', () => fetchStrings('es-ES'));
  register('es-ES', () => fetchStrings('es-ES'));
  register('pt', () => fetchStrings('pt-BR'));
  register('pt-BR', () => fetchStrings('pt-BR'));
  register('de', () => fetchStrings('de-DE'));
  register('de-DE', () => fetchStrings('de-DE'));
  register('it', () => fetchStrings('it-IT'));
  register('it-IT', () => fetchStrings('it-IT'));

  return Promise.allSettled([
    init({
      fallbackLocale: 'en',
      initialLocale:
        getLocaleFromQueryString('lang') ||
        getLocaleFromLocalStorage(LOCAL_STORAGE_KEY_LANGUAGE) ||
        getLocaleFromNavigator(),
      ignoreTag: false,
    }),
  ]);
};

export { setupI18n };
